import { Record } from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
    permissions: null,
});

class PerfisStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.SELECT_PERMISSIONS_FINISH:
                return state.set('permissions', action.permissions);

            default:
                return state;
        }
    }
}

export default new PerfisStore();




// WEBPACK FOOTER //
// src/stores/PerfisStore.js